/**
 * Hook to extract user role from MSAL token claims.
 */

import { useMsal, useAccount } from "@azure/msal-react";

export type UserRole = "admin" | "technician" | "auditor";

/**
 * Extracts the primary role from MSAL idTokenClaims.roles array.
 * Priority: admin > auditor > technician (highest privilege wins).
 */
export function useRole(): UserRole {
  const { accounts } = useMsal();
  const account = useAccount(accounts[0]);

  const roles = (account?.idTokenClaims as { roles?: string[] } | undefined)
    ?.roles ?? [];

  if (roles.includes("admin")) return "admin";
  if (roles.includes("auditor")) return "auditor";
  if (roles.includes("technician")) return "technician";

  // Default to technician if no role claim present
  return "technician";
}
